module.exports = __webpack_public_path__ + "static/media/neko-young-logo.2dab8d62.png";